import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { ColorPickerModule } from "ngx-color-picker";

import { SharedModule } from "../shared/shared.module";
import { BrandingComponent } from "./branding/branding.component";
import { CustomerComponent } from "./customer/customer.component";
import { CustomersComponent } from "./customers/customers.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { ImportCustomersComponent } from "./import-customers/import-customers.component";
import { InviteComponent } from "./invite/invite.component";
import { NewCustomerComponent } from "./new-customer/new-customer.component";
import { OrganisationRoutingModule } from "./organisation-routing.module";
import { OrganisationComponent } from "./organisation.component";
import { PreferencesComponent } from "./preferences/preferences.component";
import { StaffListComponent } from "./staff-list/staff-list.component";
import { StaffComponent } from "./staff/staff.component";
import { InviteActionsComponent } from "./staff-list/invite-actions.component";
import { FlexLayoutModule } from "@angular/flex-layout";
import { LeaderboardComponent } from "./dashboard/components/leaderboard/leaderboard.component";
import { AgmCoreModule } from "@agm/core";
import { AgmJsMarkerClustererModule } from "@agm/js-marker-clusterer";
import { CategoryListComponent } from "./dashboard/components/category-list/category-list.component";
import { ChartsModule } from "ng2-charts";
import { CheckInHealthComponent } from "./dashboard/components/checkin-health/checkin-health.component";
import { FeaturedNumberComponent } from "./dashboard/components/featured-number/featured-number.component";
import { MemoTypeGraph } from "./dashboard/components/memo-type-graph/memo-type-graph";
import { MemoCategoryGraph } from "./dashboard/components/memo-category-graph/memo-category-graph";
import { AddToTeamFormComponent } from "./customer/add-to-team/add-to-team-form.component";
import { AddToTeamDialog } from "./customer/add-to-team/add-to-team-dialog.component";
import { CustomerImportPreview } from "./import-customers/customer-import-preview/customer-import-preview";

@NgModule({
  imports: [
    AgmCoreModule,
    AgmJsMarkerClustererModule,
    OrganisationRoutingModule,
    ChartsModule,
    CommonModule,
    SharedModule,
    RouterModule,
    ColorPickerModule,
    FlexLayoutModule
  ],
  declarations: [
    AddToTeamDialog,
    AddToTeamFormComponent,
    BrandingComponent,
    CategoryListComponent,
    CheckInHealthComponent,
    CustomerComponent,
    CustomersComponent,
    CustomerImportPreview,
    DashboardComponent,
    FeaturedNumberComponent,
    ImportCustomersComponent,
    InviteActionsComponent,
    InviteComponent,
    LeaderboardComponent,
    MemoTypeGraph,
    MemoCategoryGraph,
    StaffComponent,
    StaffListComponent,
    NewCustomerComponent,
    OrganisationComponent,
    PreferencesComponent
  ],
  exports: [OrganisationComponent],
  entryComponents: [AddToTeamDialog]
})
export class OrganisationModule {}
